import { TESTIMONIALS_VIEW, TESTIMONIALS_SWIPED_TRIGGER } from './types';

export const triggerTestimonialsIsViewed = () => ({
  type: TESTIMONIALS_VIEW,
});

export const triggerTestimonialsIsSwiped = slideIndex => ({
  type: TESTIMONIALS_SWIPED_TRIGGER,
  slideIndex,
});
